import { render } from "./DataComponent.vue?vue&type=template&id=770f8270"
import script from "./DataComponent.vue?vue&type=script&lang=js"
export * from "./DataComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__